import { Type } from '@sinclair/typebox';
import { createPathGuidParameter } from '../../routes/createPathParameter';
import { makeNullable } from '../../utils/typeboxHelpers';

export const equipmentUsagePaths = {
    '/api/equipment/{equipmentId}/equipmentUsage': {
        parameters: [createPathGuidParameter('equipmentId')],
        post: {
            operationId: 'equipmentUsageControllers.create',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                id: Type.Optional(Type.String()),
                                equipmentId: Type.Optional(Type.String()),
                                surveyId: Type.String(),
                            }),
                        },
                    },
                },
            },
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            id: Type.Optional(Type.String()),
                            equipmentId: Type.Optional(Type.String()),
                            surveyId: Type.String(),
                        }),
                    },
                },
            },
        },
    },
    '/api/equipmentUsage': {
        get: {
            operationId: 'equipmentUsageControllers.getAll',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Array(
                                Type.Object({
                                    id: Type.String(),
                                    equipment: Type.Object({
                                        id: Type.String(),
                                        name: Type.String(),
                                        manufacturer: Type.String(),
                                        serialNumber: Type.String(),
                                        status: Type.String(),
                                        dateEndCertificateValidity: makeNullable(Type.String()),
                                        dateReminderRecertification: makeNullable(Type.String()),
                                        equipmentType: Type.Object({
                                            name: Type.String(),
                                            isPayload: Type.Boolean(),
                                            hasLog: Type.Boolean(),
                                        }),
                                    }),
                                }),
                            ),
                        },
                    },
                },
            },
            parameters: [{ name: 'surveyId', in: 'query', schema: Type.String(), required: true }],
        },
    },
    '/api/equipmentUsage/{equipmentUsageId}': {
        parameters: [createPathGuidParameter('equipmentUsageId')],
        delete: {
            operationId: 'equipmentUsageControllers.remove',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                ok: Type.Boolean(),
                            }),
                        },
                    },
                },
            },
        },
    },
} as const;
